"use client";

import { Button } from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import { useCookies } from "react-cookie";

import { useCompany } from "@/components/hooks/useCompany";
import { useGTMContext } from "@/providers";

import { COOKIES } from ".constants/cookies";
import { GE } from ".constants/gtmEvents";
import { PATH_AUTH } from ".constants/links";

export const LoginButton = ({ className }: { className?: string }) => {
  const t = useTranslations("Landing");
  const { onSendGTM } = useGTMContext();

  const { companyLower } = useCompany();
  const [cookies] = useCookies([
    COOKIES._R,
    COOKIES.RULES_ACCEPTED,
    COOKIES.APP,
  ]);

  const authLink = useMemo(() => {
    if (!companyLower.includes("clothoff.me")) {
      return PATH_AUTH;
    }

    if (cookies._r) {
      return `https://${companyLower}${PATH_AUTH}?utm_source=r&utm_medium=${cookies._r}`;
    }

    return `https://${companyLower}${PATH_AUTH}`;
  }, [cookies._r, companyLower]);

  return (
    <Button
      href={authLink}
      size="sm"
      variant="light"
      onClick={onSendGTM(GE.CHOOSE_WEB__HEADER)}
      disabled={!cookies.rulesAccepted && !cookies.app}
      className={className}
    >
      {t("signIn")}
    </Button>
  );
};
